<template>
	<div class="incenters">
		<div style="">
			<!---->
			<Commonbtn v-if="qx.add&&$store.state.MenusData.CusType!='经销商'" backgroundColor="#FFF"
				:src="require('@/assets/icon/icon-add.png')" title="新增" fontSize="14px" @btnclick="addckd">
			</Commonbtn>
			<el-dropdown v-if="qx.add&&$store.state.MenusData.CusType=='经销商'" style="margin-right:12px;"
				@command="handleDrop">
				<div class="drop-down-link">
					新增<i class="el-icon-arrow-down el-icon--right"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="a">出库单</el-dropdown-item>
					<el-dropdown-item command="b">销售退货单</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" :optional="editops" :useAutoOptional="false" opwidth="72px" top="370px"
				:src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" @btnclick="updateckd">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="审核" fontSize="14px" @btnclick="shen"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.revoke" title="弃审" fontSize="14px" @btnclick="qshen"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="DespatchExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" title="出库单导入" fontSize="14px" @getFile="Import"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="指导视频" fontSize="14px" @btnclick="GuidanceVideo"
				:src="require('@/assets/icon/video.png')">
			</Commonbtn> <a
				style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="dowloadBtn">下载出库单导入模版</a>

		</div>
		<div class="TableWidth">
			<Commontable ref="OutboudreRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="CusTypeFlog == 0 ? headerData : headerDataTow" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>



		<DialogFrom ref="dialogadd" width="1000px" title="选择出库单" :OKASCAN="false"
			:dialogVisible="dialogVisibleoutboundorder2" @cancel="dialogVisibleoutboundorder2 = false">
			<div style="height: 700px; overflow-y: scroll;overflow-x: hidden;">
				<div style="padding-top:0px;height:195px;" :class=" showorhide ? 'inputtopt' : 'inputtops' ">
					<div style="display: inline-block;" v-for="(item , index) of selectformdata" :key="index">
						<Commondropdownlist ref="outselect" v-if="!item.hidden" :inputflag="item.inputflag"
							:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width">
						</Commondropdownlist>
					</div>
					<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
						<CommonBtngroup ref="btngroup" :qhide="false" :show="showorhide" @select="handSelect"
							@reset="handReset"></CommonBtngroup>
					</div>
					<div style="height:10px;">
					</div>
				</div>
				<Commonbtn backgroundColor="#FFF" title="选择" fontSize="14px" @btnclick="invSel2"
					:src="require('@/assets/icon/shen.png')">
				</Commonbtn>
				<div style="width: 970px;margin-top: 10px;overflow: scroll;">
					<Commontable :loadingTable="false" ref="OutboudreRef2"
						@handleSelectionChange="handleSelectionChange2" @onRowClick="onRowClickSel" colnum=511
						:tableData="tableData2" :headerData="headerData" height="100%">
					</Commontable>
				</div>
				<div class="pagination">
					<Pagination @handleCurrentChange="handleCurrentChange2" @handleSizeChange="handleSizeChange2"
						:total="total2"></Pagination>
				</div>
				<div style="width: 970px;">
					<Outboundreportmanagement :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique"
						:dpmid="dpmid"></Outboundreportmanagement>
				</div>
			</div>
		</DialogFrom>



		<DialogFrom ref="dialogadd" width="1000px" title="新增出库单" :OKASCAN="false"
			:dialogVisible="dialogVisibleoutboundorder" @cancel="canceloutboundorder"
			@dialogOK="dialogOKcanceloutboundorder">
			<div class="froms">
				<div style="border-bottom: 1px solid #f0f0f0;">
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
						fontSize="14px" @btnclick="addsave">
					</Commonbtn>
					<div v-if="Detailflag" style="display: inline-block">
						<CommonbtnUpLoad v-if="!dialogVisibleoutboundorder2" backgroundColor="#FFF" title="上传出库明细"
							fontSize="14px" @getFile="UnImport" :src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a v-if="!dialogVisibleoutboundorder2"
							style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="dowload">下载导入模版</a>
					</div>
					<div v-if="Uniqueflag" style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库唯一码明细" fontSize="14px" @getFile="UniqImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="Uniqdowload">下载导入模版</a>
					</div>
				</div>

				<div style="width: 960px;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 15px;animation: shows 0.2s linear;overflow: hidden;"
					v-if="showorhide">
					<div v-for="(item , index) of formdatadialog" :key="index+'add'" style="display: inline-block;">
						<Commondropdownlist ref="outadd" :loading="loading" :selcoms="item.selcoms"
							:checkFlag="item.checkFlag" @remoteHosType="remoteHosType" :event="item.event"
							@invClass="invClass" @HosTypeChage="HosTypeChage" @remoteMethodtows="remoteMethodtows"
							@handleCheckedCitiesChange="handleCheckedCitiesChange" :btx="item.btx" :key="index"
							@voucherTypeChange="voucherTypeChange" @terminalHospitalChange="terminalHospitalChange"
							:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width" :disabled="item.disabled"
							:checkboxdata="item.checkboxdata" :inputflag="item.inputflag" :dateFlag="item.dateFlag">
						</Commondropdownlist>
					</div>
					<el-checkbox v-if="CusTypeFlog == 2" style="padding: 14px 24px;color:rgb(51, 51, 51)"
						v-model="Consignment" :disabled="ConsignmentDisabled"
						@change="(e)=>formdatadialog[12].selcoms = e">是否寄售 </el-checkbox>
				</div>
			</div>
			<div style="width: 970px;">
				<AddDialogFromTable :hiddenAdd="dialogVisibleoutboundorder2" :wtypes="wtypes" :hospital="hospital"
					:consignment="Consignment" :invClassCode="invClassCode" ref="AddDialog"
					@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="addclick" width="500px"
					colnum=7 :dpmid="dpmid" :state="state" :tableData="tableDataMD" height="100%">
				</AddDialogFromTable>
			</div>

		</DialogFrom>
		<DialogFrom width="1000px" title="修改出库单" :OKASCAN="false" :dialogVisible="dialogVisibleoutboundorderedit"
			@cancel="canceloutboundorderedit" @dialogOK="dialogOKcanceloutboundorderedit">
			<div class="froms">
				<div style="border-bottom: 1px solid #f0f0f0;">
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
						fontSize="14px" @btnclick="editsave">
					</Commonbtn>
					<div v-if="Detailflag" style="display: inline-block">
						<CommonbtnUpLoad v-if="!hiddenBtn" backgroundColor="#FFF" title="上传出库明细" fontSize="14px"
							@getFile="UnImport" :src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a v-if="!hiddenBtn"
							style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="dowload">下载导入模版</a>
					</div>
					<div v-if="Uniqueflag" style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库唯一码明细" fontSize="14px" @getFile="UniqImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="Uniqdowload">下载导入模版</a>
					</div>

				</div>
				<div class="inputtop"
					style="width: 960px !important;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 15px;animation: shows 0.2s linear;overflow: hidden;"
					v-if="showorhide">
					<div v-for="(item , index) of editformdatadialog" :key="index+'update'"
						style="display: inline-block;">
						<Commondropdownlist ref="outupdate" :loading="loading" :selcoms="item.selcoms"
							:checkFlag="item.checkFlag" @remoteHosType="remoteHosType" :event="item.event"
							@invClass="invClass" @HosTypeChage="HosTypeChage" @remoteMethodtows="remoteMethodtows"
							@handleCheckedCitiesChange="handleCheckedCitiesChangeEdit" :btx="item.btx" :key="index"
							@voucherTypeChange="voucherTypeChange" @terminalHospitalChange="terminalHospitalChange"
							:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width" :disabled="item.disabled"
							:inputflag="item.inputflag" :checkboxdata="item.checkboxdata" :dateFlag="item.dateFlag">
						</Commondropdownlist>
					</div>
					<el-checkbox v-if="CusTypeFlog == 2" style="padding: 14px 24px;color:rgb(51, 51, 51)"
						v-model="Consignment" @change="(e)=>editformdatadialog[12].selcoms = e">是否寄售</el-checkbox>
				</div>
			</div>
			<div style="width: 970px;">
				<AddDialogFromTable ref="AddDialog" :hiddenAdd="hiddenBtn" :invClassCode="invClassCode"
					:consignment="Consignment" :hospital="hospital" :dialogindex="dialogindex"
					@handleSelectionChanges="handleSelectionChanges"
					@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="uaddclick" width="500px"
					:dpmid="dpmid" :state="state" :tableData="tableDataMD" height="100%">
				</AddDialogFromTable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="出库上报管理指导视频" :OKASCAN="false" :dialogVisible="dialogVisibGuidanceVideo"
			@cancel="cancelGuidanceVideo" @dialogOK="dialogOKGuidanceVideo">
			<VideoPlayer ref="outbouVideo" v-if="dialogVisibGuidanceVideo"
				:srcVideo="require('../../../../assets/video/outbou/outbou.mp4')">
			</VideoPlayer>
		</DialogFrom>
		<DialogFrom width="648px" title="发票照片标注" :dialogVisible="dialogVisiblesinvoicephoto"
			@cancel="cancelinvoicephoto" @dialogOK="dialogOKinvoicephoto">
			<div style="color: #333333;font-size: 14px;">
				请填写发票照片校验状态标注：
			</div>
			<textarea style="border: 1px solid #E6E6E6;width: 608px;height: 180px;margin-top: 10px;"></textarea>
		</DialogFrom>
		<DialogFrom width="890px" title="导入结果" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesqsjg" @cancel="cancelqsjg"
			@dialogOK="dialogOKqsjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDataqsjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="提示" :dialogVisible="dialogVisibleUpload" @cancel="dialogUnTips"
			leftText="今日不再提醒" @dialogOK="dialogClose">
			<div class="from">
				<Commontable width="830px" colnum=300 :tableData="tableDataUpload" height="100%" />
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条出库上报信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqshen" @cancel="cancelqshen"
			@dialogOK="dialogOKqshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要弃审这条出库上报信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleshen" @cancel="cancelshen"
			@dialogOK="dialogOKshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核通过这条出库上报信息吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Dialog from '../../../../components/dialog.vue'
	import AddDialogFromTable from './components/addDialogFromTable.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import addformdatadialog from '../fromData/addformdatadialog'
	import editformdatadialog from '../fromData/editformdatadialog'
	import headerData from '../table/headerData'
	import headerDataTow from '../table/headerDataTow'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import VideoPlayer from '../../../../components/videoPlayer.vue'
	import Outboundreportmanagement from './outboundreportmanagement-bottom.vue'
	import {
		wmsDespatchInfo,
		DespatchImportDetail,
		HelperDPVoucherTypeForEdit,
		HelperDPVoucherType,
		InventoryClassList,
		wmsDespatchImport,
		CusType,
		CustomerList,
		HospitalList,
		wmsDespatchDelete,
		wmsDespatchVerify,
		wmsDespatchUnVerify,
		InventoryClassInfo,
		DespatchDownloadDetailTemplet,
		DespatchImportUnique,
		DespatchDownloadUniqueTemplet,
		DespatchDownloadTemplet,
		DespatchEdit,
		DespatchAdd,
		HospitalInfo,
		wmsDespatchList,
		wmsDespatchDetail,
		wmsDespatchDetailUnique,
		GetDespatchDetailByDPMIDs,
		NoMoreWarningConvertRateToday,
		Status,
		HelperTechnicalOfficesList
	} from '@/api/home'
	export default {
		name: 'outnoundreport',
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonBtngroup,
			AddDialogFromTable,
			CommonbtnUpLoad,
			VideoPlayer,
			Outboundreportmanagement
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				lastTargetHospitalId: null,
				unTipsParams: {},
				tableDataUpload: [],
				dialogVisibleUpload: false,
				ConsignmentDisabled: false,
				hospital: '',
				Consignment: false,
				dialogVisibleoutboundorderedit: false,
				dialogVisibles: false,
				dialogVisibleshen: false,
				dialogVisibleqshen: false,
				dialogVisibleqdel: false,
				dialogVisiblesinvoicephoto: false,
				dialogVisibledel: false,
				dialogVisibleoutboundorder: false,
				dialogVisiblesdrjg: false,
				dialogVisiblesqsjg: false,
				dialogVisibGuidanceVideo: false,
				Detailflag: true,
				Uniqueflag: false,
				editops: true,
				showorhide: true,
				rowboo: false,
				loading: false,
				dpmid: null,
				// optionalupdate: false,
				CusTypeFlog: null,
				tableDataqsjg: [],
				formdatadialog: [],
				editformdatadialog: [],
				dpmidarr: [],
				invClassCode: "",
				title: '',
				dialogindex: '',
				TerminalHospital: '',
				TerminalHospitalName: '',
				wtypes: 1,
				HosTypestate: null,
				headerData: [],
				headerDataTow: [],
				fromdatalists: [{
					inputdata: '',
					fontSize: '14px',
					color: '#333333',
					placeholder: '颜色说明',
					types: '',
					inputtype: 'selects',
					width: '110px',
				}, ],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
				},
				tableDatadrjg: [],
				AddTableSelectiondetailList: [],
				AddTableSelectiondetailUniqueList: [],
				state: [{
					title: '明细'
				}, ],
				CusTypeState: "",
				HospitalCode: "",
				CusCode: "",
				HospitalName: "",
				CusCodeName: "",
				dialogVisibleoutboundorder2: false,
				tableData2: [],
				total2: 0,
				selectformparams: {},
				selectformdatalist: [],
				pageSize2: 20,
				pageindex2: 1,
				tableDataDetail: [],
				tableDataUnique: [],
				dpmidarr2: [],
				hiddenBtn: false,
				selectformdata: [{
						inputdata: '',
						title: '平台/经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '150px',
						lablewith: '95px',
						inputflag: false
					},
					{
						inputdata: '',
						title: '经销商单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '150px',
						lablewith: '95px',
						options: [],
						selcoms: false,
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "150px",
						lablewith: '85px'
					},
					{
						inputdata: '',
						title: '付款方名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '150px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '160px',
						lablewith: '80px',
						options: [],
					},

					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '160px',
						lablewith: '80px',
						options: [],
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "160px",
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '160px',
						lablewith: '80px',
						options: []
					},
					{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '90px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '70px'
					},
				],
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.formdatadialog = JSON.parse(JSON.stringify(addformdatadialog))
			this.editformdatadialog = JSON.parse(JSON.stringify(editformdatadialog))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
			this.QX()
			if (this.$route.query.openAdd && this.$route.query.DPMIDs) {
				this.handleAutoOpenAdd(this.$route.query.DPMIDs);
			}
		},
		methods: {
			async handleAutoOpenAdd(DPMIDs) {
				const loading = this.$loading({
					lock: true,
					text: '正在加载数据...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				try {
					let {
						data,
						code,
						message
					} = await GetDespatchDetailByDPMIDs({
						DPMIDs: DPMIDs.split(',')
					});
					if (code == 0) {
						this.addckd(); // Open the add dialog
						this.$nextTick(() => {
							this.inventoryClassList()
							this.helperDPVoucherType()

							this.Consignment = data.Consignment ? true : false;
							this.ConsignmentDisabled = true;
							this.formdatadialog[2].disabled = true;
							this.formdatadialog[2].inputdata = data.InvClass;

							this.formdatadialog[3].disabled = true;
							this.formdatadialog[3].options = [{
								key: data.VoucherType,
								value: data.VoucherType
							}];
							this.formdatadialog[3].inputdata = data.VoucherType;

							this.formdatadialog[4].disabled = true;
							this.formdatadialog[4].options = [{
								key: data.Hospital,
								value: data.CusName
							}];
							this.formdatadialog[4].inputdata = data.Hospital;

							if (data.SellerType == "医院") {
								this.formdatadialog[6].selcoms = false
							} else {
								this.formdatadialog[6].selcoms = true
								this.formdatadialog[6].disabled = true;
								this.formdatadialog[6].options = [{
									key: data.TerminalHPID,
									value: data.TerminalHPName
								}];
								this.formdatadialog[6].inputdata = data.TerminalHPID;
							}

							this.$nextTick(() => {
								if (this.$refs.AddDialog.tableDataDetail) {
									this.$refs.AddDialog.tableDataDetail.length = 0
								}
								data.data.map((item, index) => {
									item.ID = index;
									return item;
								})
								this.$refs.AddDialog.tableDataDetail = data.data
								this.$refs.AddDialog.tableDataDetailunNo = data.data
							})

							this.$forceUpdate();
							this.dialogVisibleoutboundorder = true;
						});
					} else {
						this.$message.error(message);
					}
				} catch (e) {
					console.error(e);
				} finally {
					loading.close();
				}
			},
			addCheckbox(e) {
				console.log(e);
				this.formdatadialog[12].selcoms = false;
			},
			editCheckbox(e) {
				console.log(e);
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == 18) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 20) {
								this.qus = items.Nodes
							}
						})
					}
				})
				//console.log(this.qus, 'qus');
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'revoke') {
							this.qx.revoke = true
						}
					})
				}
				this.CusType()
			},
			async dowloadBtn() {
				let {
					data,
					code,
					message
				} = await DespatchDownloadTemplet({})

				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载模板
			async dowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await DespatchDownloadDetailTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 上传出库明细
			async UnImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await DespatchImportDetail(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					//console.log(this.$refs.AddDialog, 'adddialog');
					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					// data.DetailList.map((item, index) => {
					//   this.$refs.AddDialog.tableDataDetail.push(item)
					// })
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 上传出库唯一码明细
			async UniqImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await DespatchImportUnique(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					let arr = []
					let obj = {}
					data.UniqueList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						obj = Object.assign({}, item, {
							ids: num
						})
						arr.push(obj)
					})


					this.$refs.AddDialog.tableDataDetailUnique = arr
					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 下载出库唯一码明细
			async Uniqdowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"

				let {
					data,
					code,
					message
				} = await DespatchDownloadUniqueTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			async DespatchEditOne(val = false) {
				// if (!this.$refs.outupdate[0].modelvalue) {
				//   this.$message.warning("出库单号不能为空！")
				//   return
				// }

				if (!this.$refs.outupdate[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outupdate[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outupdate[3].modelvalue) {
					this.$message.warning("单据类型不能为空！")
					return
				}

				// if (!this.$refs.outupdate[4].modelvalue) {
				// 	this.$message.warning("付款方不能为空！")
				// 	return
				// }

				let params = {
					dpmid: this.dpmid,
					dpDate: this.$refs.outupdate[1].modelvalue, //出库日期
					voucherType: this.$refs.outupdate[3].modelvalue, //单据类型
					invClass: this.$refs.outupdate[2].modelvalue, //产品线编码
					vouCode: this.$refs.outupdate[0].modelvalue, //经销商出库单号
					// cusCode: this.$refs.outupdate[4].modelvalue == this.CusCodeName ? this.CusCode : this.$refs.outupdate[4].modelvalue,//二级经销商编号   
					//hospital: this.$refs.outupdate[4].modelvalue, //医院编号 
					terminalHospital: this.$refs.outupdate[6]
						.modelvalue, //终端医院（二级经销商创建的出库单，且填写的hospital的HosType!=医院时传）
					remark: this.$refs.outupdate[5].modelvalue, //备注
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: this.$refs.AddDialog.tableDataDetailUnique, //出库唯一码明细（产品线开通唯一码时传）
					Consignment: this.Consignment ? 1 : 0,
					OrgConsignment: this.$refs.outupdate[7].modelvalue ? Number(this.$refs.outupdate[7]
						.modelvalue) : 0,
					SurgeryDate: this.$refs.outupdate[8].modelvalue,
					SurgeryType: this.$refs.outupdate[9].modelvalue,
					TechnicalOfficesID: this.editformdatadialog[10].inputtype === 'input' ? "" : this.$refs.outupdate[10].modelvalue,
					TechnicalOffices: this.editformdatadialog[10].inputtype === 'input' ? this.$refs.outupdate[10].modelvalue : "",
					Doctor: this.$refs.outupdate[11].modelvalue,
				}
				console.log(this.$store.state.MenusData.CusType, params)
				if (this.$store.state.MenusData.CusType == '经销商' && params.voucherType != '销售退货单') {
					params.IsEdit = 1;
				}

				params[this.CusTypeFlog === 1 ? 'CusCode' : 'hospital'] = this.$refs.outupdate[4].modelvalue;

				if (this.Consignment) {
					params.ConsignHospital = this.$refs.outupdate[12].modelvalue;
				}

				this.unTipsParams = params;

				if (val) {
					params.IsForce = 1;
				}

				console.log(params)

				let {
					code,
					data,
					message
				} = await DespatchEdit(params)

				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsDespatchList()
					this.dialogVisibleoutboundorderedit = false
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else if (code == 300) {
					this.dialogVisibleUpload = true;
					this.tableDataUpload = data;
				} else if (code == 400) {
					this.$confirm(message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.DespatchEditOne(true);
					}).catch(() => {});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			async DespatchEditTow(val = false) {
				// if (!this.$refs.outupdate[0].modelvalue) {
				//   this.$message.warning("出库单号不能为空！")
				//   return
				// }
				if (!this.$refs.outupdate[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outupdate[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outupdate[3].modelvalue) {
					this.$message.warning("单据类型不能为空！")
					return
				}
				// if (!this.$refs.outupdate[4].modelvalue) {
				// 	this.$message.warning("付款方不能为空！")
				// 	return
				// }

				let params = {
					dpmid: this.dpmid,
					dpDate: this.$refs.outupdate[1].modelvalue, //出库日期
					voucherType: this.$refs.outupdate[3].modelvalue, //单据类型
					invClass: this.$refs.outupdate[2].modelvalue, //产品线编码
					vouCode: this.$refs.outupdate[0].modelvalue, //经销商出库单号
					//cusCode: this.$refs.outupdate[4].modelvalue, //二级经销商编号
					// hospital: this.$refs.outupdate[4].modelvalue == this.HospitalName ? this.HospitalCode : this.$refs.outupdate[4].modelvalue,//医院编号
					//hospital: this.$refs.outupdate[4].modelvalue, //医院编号 
					terminalHospital: this.$refs.outupdate[6]
						.modelvalue, //终端医院（二级经销商创建的出库单，且填写的hospital的HosType!=医院时传）
					remark: this.$refs.outupdate[5].modelvalue, //备注
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: null, //出库唯一码明细（产品线开通唯一码时传）
					OrgConsignment: this.$refs.outupdate[7].modelvalue ? Number(this.$refs.outupdate[7]
						.modelvalue) : 0,
					SurgeryDate: this.$refs.outupdate[8].modelvalue,
					SurgeryType: this.$refs.outupdate[9].modelvalue,
					TechnicalOfficesID: this.editformdatadialog[10].inputtype === 'input' ? "" : this.$refs.outupdate[10].modelvalue,
					TechnicalOffices: this.editformdatadialog[10].inputtype === 'input' ? this.$refs.outupdate[10].modelvalue : "",
					Doctor: this.$refs.outupdate[11].modelvalue,
				}
				console.log(this.$store.state.MenusData.CusType, params.voucherType)
				if (this.$store.state.MenusData.CusType == '经销商' && params.voucherType != '销售退货单') {
					params.IsEdit = 1;
				}
				params[this.CusTypeFlog === 1 ? 'CusCode' : 'hospital'] = this.$refs.outupdate[4].modelvalue;

				this.unTipsParams = params;

				if (val) {
					params.IsForce = 1;
				}

				console.log(params)
				let {
					code,
					data,
					message
				} = await DespatchEdit(params)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsDespatchList()
					this.dialogVisibleoutboundorderedit = false
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else if (code == 300) {
					this.dialogVisibleUpload = true;
					this.tableDataUpload = data;
				} else if (code == 400) {
					this.$confirm(message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.DespatchEditTow(true);
					}).catch(() => {});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			async DespatchAddOne(val = false) {
				// if (!this.$refs.outadd[0].modelvalue) {
				//   this.$message.warning("出库单号不能为空！")
				//   return
				// }
				if (!this.$refs.outadd[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outadd[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outadd[3].modelvalue) {
					this.$message.warning("单据类型不能为空！")
					return
				}
				// if (!this.$refs.outadd[4].modelvalue) {
				// 	this.$message.warning("付款方不能为空！")
				// 	return
				// }
				let params = {
					dpDate: this.$refs.outadd[1].modelvalue, //出库日期
					voucherType: this.$refs.outadd[3].modelvalue, //单据类型
					invClass: this.$refs.outadd[2].modelvalue, //产品线编码
					vouCode: this.$refs.outadd[0].modelvalue, //经销商出库单号
					// cusCode: this.$refs.outadd[4].modelvalue,//二级经销商编号
					Hospital: this.$refs.outadd[4].modelvalue, //医院编号
					terminalHospital: this.$refs.outadd[6]
						.modelvalue, //终端医院（二级经销商创建的出库单，且填写的hospital的HosType!=医院时传）
					remark: this.$refs.outadd[5].modelvalue, //备注
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: this.$refs.AddDialog.tableDataDetailUnique, //出库唯一码明细（产品线开通唯一码时传）
					Consignment: this.Consignment ? 1 : 0,
					OrgConsignment: this.$refs.outadd[7].modelvalue ? Number(this.$refs.outadd[7].modelvalue) : 0,
					SurgeryDate: this.$refs.outadd[8].modelvalue,
					SurgeryType: this.$refs.outadd[9].modelvalue,
					TechnicalOfficesID: this.formdatadialog[10].inputtype === 'input' ? "" : this.$refs.outadd[10].modelvalue,
					TechnicalOffices: this.formdatadialog[10].inputtype === 'input' ? this.$refs.outadd[10].modelvalue : "",
					Doctor: this.$refs.outadd[11].modelvalue,
				};
				console.log(this.$store.state.MenusData.CusType, params.voucherType)
				if (this.$store.state.MenusData.CusType == '经销商' && params.voucherType != '销售退货单') {
					params.IsEdit = 1;
				}

				if (this.Consignment) {
					params.ConsignHospital = this.$refs.outadd[12].modelvalue;
				}

				this.unTipsParams = params;

				if (val) {
					params.IsForce = 1;
				}

				console.log(params);
				let {
					code,
					data,
					message
				} = await DespatchAdd(params)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsDespatchList()
					this.dialogVisibleoutboundorder = false
					this.dialogVisibleoutboundorder2 = false;
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()

				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else if (code == 300) {
					this.dialogVisibleUpload = true;
					this.tableDataUpload = data;
				} else if (code == 400) {
					this.$confirm(message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.DespatchAddOne(true);
					}).catch(() => {});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			async DespatchAddTow(val = false) {
				// //console.log(this.$refs.AddDialog,'this.$refs.AddDialog');
				// let arr1= [] 
				// this.$refs.AddDialog.tableDataDetailunNo.map((item,index)=>{
				//   let obj = {
				//     invCode: item.InvCode,
				//     batch: item.Batch,
				//     quantity: item.Quantity == "" ? null : "",
				//     taxUnitPrice: null,
				//   }
				//   arr1.push(obj)
				// if (!this.$refs.outadd[0].modelvalue) {
				//   this.$message.warning("出库单号不能为空！")
				//   return
				// }
				if (!this.$refs.outadd[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outadd[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outadd[3].modelvalue) {
					this.$message.warning("单据类型不能为空！")
					return
				}
				// if (!this.$refs.outadd[4].modelvalue) {
				// 	this.$message.warning("付款方不能为空！")
				// 	return
				// }
				// })

				let params = {
					dpDate: this.$refs.outadd[1].modelvalue, //出库日期
					voucherType: this.$refs.outadd[3].modelvalue, //单据类型
					invClass: this.$refs.outadd[2].modelvalue, //产品线编码
					vouCode: this.$refs.outadd[0].modelvalue, //经销商出库单号
					cusCode: this.$refs.outadd[4].modelvalue, //二级经销商编号
					// hospital: this.$refs.outadd[4].modelvalue,//医院编号
					terminalHospital: this.$refs.outadd[6]
						.modelvalue, //终端医院（二级经销商创建的出库单，且填写的hospital的HosType!=医院时传）
					remark: this.$refs.outadd[5].modelvalue, //备注
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: null, //出库唯一码明细（产品线开通唯一码时传）
					OrgConsignment: this.$refs.outadd[7].modelvalue ? Number(this.$refs.outadd[7].modelvalue) : 0,
					SurgeryDate: this.$refs.outadd[8].modelvalue,
					SurgeryType: this.$refs.outadd[9].modelvalue,
					TechnicalOfficesID: this.formdatadialog[10].inputtype === 'input' ? "" : this.$refs.outadd[10].modelvalue,
					TechnicalOffices: this.formdatadialog[10].inputtype === 'input' ? this.$refs.outadd[10].modelvalue : "",
					Doctor: this.$refs.outadd[11].modelvalue,
				}
				//console.log(this.$store.state.MenusData.CusType, params.voucherType)
				if (this.$store.state.MenusData.CusType == '经销商' && params.voucherType != '销售退货单') {
					params.IsEdit = 1;
				}

				this.unTipsParams = params;

				if (val) {
					params.IsForce = 1;
				}

				console.log(params);
				let {
					code,
					data,
					message
				} = await DespatchAdd(params)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsDespatchList()
					this.dialogVisibleoutboundorder = false;
					this.dialogVisibleoutboundorder2 = false;
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else if (code == 300) {
					this.dialogVisibleUpload = true;
					this.tableDataUpload = data;
				} else if (code == 400) {
					this.$confirm(message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.DespatchAddTow(true);
					}).catch(() => {});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			// 添加保存
			addsave() {
				console.log(this.CusTypeFlog)
				if (this.CusTypeFlog == 2) {
					//console.log(this.$refs.AddDialog, "添加1");
					this.DespatchAddOne()
				} else if (this.CusTypeFlog == 1) {
					//console.log(this.$refs.AddDialog, "添加");
					this.DespatchAddTow()
				}
			},
			// 修改保存
			editsave() {
				console.log(this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
					.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail)
				if (this.CusTypeFlog == 2) {
					this.DespatchEditOne()
				} else if (this.CusTypeFlog == 1) {
					this.DespatchEditTow()
				}

			},
			// 详情
			async wmsDespatchInfo() {
				let {
					code,
					data

				} = await wmsDespatchInfo({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.editformdatadialog[8].dateFlag = false;
					this.editformdatadialog[9].inputflag = false;
					this.editformdatadialog[10].inputflag = false;
					this.editformdatadialog[11].inputflag = false;

					this.$refs.outupdate[0].modelvalue = data.VouCode
					this.$refs.outupdate[1].modelvalue = data.DPDate
					this.$refs.outupdate[2].modelvalue = data.InvClass
					this.$refs.outupdate[3].modelvalue = data.VoucherType
					this.$refs.outupdate[5].modelvalue = data.Remark
					this.$refs.AddDialog.tableDataDetail.length = 0
					let arr = []
					let obj = {}
					data.DetailUniqueList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						obj = Object.assign({}, item, {
							ids: num
						})
						arr.push(obj)
					})
					if (data.DetailList && data.DetailList.length) {
						let CorID = data.DetailList[0].CorID
						if (CorID) {
							this.editformdatadialog[2].disabled = true;
							this.editformdatadialog[3].disabled = true;
							this.editformdatadialog[4].disabled = true;
							this.editformdatadialog[6].disabled = true;
							this.hiddenBtn = true;
						}
					}


					this.$refs.outupdate[8].modelvalue = data.SurgeryDate;
					this.$refs.outupdate[9].modelvalue = data.SurgeryType;
					this.$refs.outupdate[10].modelvalue = (data.TechnicalOfficesID && data.TechnicalOfficesID !== 0) ? data.TechnicalOfficesID : data.TechnicalOffices;
					this.$refs.outupdate[11].modelvalue = data.Doctor;

					if (data.TerminalHospitalName) {
						this.$refs.outupdate[6].modelvalue = data.TerminalHospital;
						this.remoteHosType(data.TerminalHospitalName);
					}

					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					this.$refs.AddDialog.tableDataDetailUnique = arr
					if (this.CusTypeFlog == 1) {
						this.$refs.outupdate[4].modelvalue = data.CusCode
						this.CusCode = data.CusCode
						this.CusCodeName = data.CusName
						this.editformdatadialog[4].options = [{
							value: data.CusName,
							key: data.CusCode
						}]

					}
					if (this.CusTypeFlog == 2) {
						// if(data.TerminalHospitalName){
						// this.$refs.outupdate[6].selcoms = true
						// }
						this.$refs.outupdate[4].modelvalue = data.Hospital
						this.$refs.outupdate[6].modelvalue = data.TerminalHospital
						this.TerminalHospitalName = data.TerminalHospitalName
						this.TerminalHospital = data.TerminalHospital
						this.HospitalCode = data.Hospital
						this.HospitalName = data.HospitalName

						this.editformdatadialog[4].options = [{
							value: data.HospitalName,
							key: data.Hospital
						}]
						this.HospitalListID(data.Hospital)
					}
					if (data.OrgConsignment) {
						this.editformdatadialog[6].selcoms = true;
						this.editformdatadialog[8].dateFlag = true;
						this.editformdatadialog[9].inputflag = true;
						this.editformdatadialog[10].inputflag = true;
						this.editformdatadialog[11].inputflag = true;
						this.$forceUpdate();
					}


					if (data.Consignment) {
						this.Consignment = true;
						this.editformdatadialog[12].selcoms = true;
						this.$refs.outupdate[12].modelvalue = data.ConsignHospital
						this.editformdatadialog[12].options = [{
							value: data.ConsignHospitalName,
							key: data.ConsignHospital
						}]
					}

					this.$refs.outupdate[7].modelvalue = data.OrgConsignment ? '1' : '0'
					this.inventoryClassInfo(this.$refs.outupdate[2].modelvalue)
					
					this.$nextTick(() => {
						this.checkTechnicalOfficesVisibility();
					});
					// this.$refs.AddDialog.wmsDespatchDetail()
				}
			},
			// 单据类型下拉（编辑/新增界面用新接口）
			async helperDPVoucherType() {
				let {
					code,
					data
				} = await HelperDPVoucherTypeForEdit({})
				if (code == 0) {
					this.formdatadialog[3].options = []
					this.editformdatadialog[3].options = []
					let arr = [];
					data.map((item, index) => {
						arr.push({
							key: item.Value,
							value: item.Text
						})
					})
					this.formdatadialog[3].options = arr;
					this.editformdatadialog[3].options = arr;
				}
			},
			// 单据类型下拉（选择出库单弹窗用旧接口）
			async helperDPVoucherTypeForSelect() {
				let {
					code,
					data
				} = await HelperDPVoucherType({})
				if (code == 0) {
					this.selectformdata[7].options = []
					data.map((item, index) => {
						this.selectformdata[7].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdatadialog[2].options = []
					this.editformdatadialog[2].options = []
					this.selectformdata[5].options = []
					let arr = [];
					data.data.map((item, index) => {
						arr.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
					this.formdatadialog[2].options = arr;
					this.editformdatadialog[2].options = arr;
					this.selectformdata[5].options = arr;
				}
			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.selectformdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.selectformdata[4].options.push(obj)
					})
				}
			},
			// 导入
			async Import(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await wmsDespatchImport(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
				} else if (code == 300) {
					this.dialogVisibleUpload = true;
					this.tableDataUpload = data;
					loading.close();
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
				this.$parent.wmsDespatchList()
			},
			// 判断修改是否可用
			async CusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					this.CusTypeState ='平台';  //data.CusType
					if (data.CusType == "") {
						this.editops = true //测试中
						this.CusTypeFlog = 0
						this.formdatadialog[7].checkFlag = false;
						this.editformdatadialog[7].checkFlag = false;
					} else if (data.CusType == "平台") {
						this.CusTypeFlog = 1;
						this.formdatadialog[7].checkFlag = true;
						this.editformdatadialog[7].checkFlag = true;
					} else if (data.CusType == "经销商") {
						this.CusTypeFlog = 2
						this.formdatadialog[7].checkFlag = false;
						this.editformdatadialog[7].checkFlag = false;
					}
					this.$forceUpdate();
					console.log('========>', this.CusTypeFlog, this.formdatadialog[7]);
				}
			},
			// 删除
			async wmsDespatchDelete() {
				let {
					code,
					message,
					data
				} = await wmsDespatchDelete({
					dpmiDs: this.dpmidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.dpmidarr.length = 0
					this.$parent.wmsDespatchList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "删除结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			// 审核
			async wmsDespatchVerify() {
				let {
					code,
					message,
					data
				} = await wmsDespatchVerify({
					dpmiDs: this.dpmidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '审核成功'
					});
					this.dpmidarr.length = 0
					this.$parent.wmsDespatchList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					if (data&&data.length > 0) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.success(message);
					}
					this.dpmidarr.length = 0
					this.$parent.wmsDespatchList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "审核结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			// 弃审
			async wmsDespatchUnVerify() {
				let {
					code,
					message,
					data
				} = await wmsDespatchUnVerify({
					dpmiDs: this.dpmidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '弃审成功'
					});
					this.dpmidarr.length = 0
					this.$parent.wmsDespatchList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					if (data&&data.length > 0) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.success(message);
					}
					this.dpmidarr.length = 0
					this.$parent.wmsDespatchList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "弃审结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			async despatchImportDetail() {
				let {
					code,
					message
				} = await DespatchImportDetail({
					DetailList: this.AddTableSelection
				})
			},
			async HospitalListID(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalInfo({
					hpid: query,
				})
				if (code == 0) {
					if (this.CusTypeFlog == 2 || this.CusTypeFlog == 1) {
						if (data.HosType == "医院") {
							this.formdatadialog[6].selcoms = false
							this.editformdatadialog[6].selcoms = false
						} else {
							this.formdatadialog[6].selcoms = true
							this.editformdatadialog[6].selcoms = true
						}
					}
					this.checkTechnicalOfficesVisibility();
				}
				this.loading = false
			},
			// 终端医院（二级经销商创建的出库单，且填写的hospital的HosType
			HosTypeChage(e) {
				if (e.modelvalue == '') {
					if (this.dialogVisibleoutboundorderedit) {
						this.$refs.outupdate[6].modelvalue = ''
						this.editformdatadialog[6].selcoms = false
					} else if (this.dialogVisibleoutboundorder) {
						this.$refs.outadd[6].modelvalue = ''
						this.formdatadialog[6].selcoms = false
					}
				}
				if (this.CusTypeFlog == 2) {
					if (e.modelvalue != '') {
						this.HospitalListID(e.modelvalue)
					}
				}
			},
			//多选
			handleSelectionChange(val) {
				this.handleData = val
				if (val) {
					this.dpmidarr = []
					val.map((item, index) => {
						this.dpmidarr.push(item.DPMID)
					})
				}
				
				if (val && val.length === 1) {
					this.rowboo = true
					this.dpmid = val[0].DPMID
					this.editops = val[0].Status == 0 ? false : true
					return
				}
				this.rowboo = false
				this.editops = true
				if (!val || val.length === 0) {
					this.dpmid = ""
				}

			},
			//多选
			handleSelectionChange2(val) {
				if (val) {
					this.dpmidarr2 = []
					// this.rowboo = true
					val.map((item, index) => {
						this.dpmidarr2.push(item.DPMID)
					})
				} else {
					this.rowboo = false
				}

			},
			handleSelectionChangeAddDialogFromTable(val) {
				this.AddTableSelectiondetailList = val
			},
			handleSelectionChanges() {},
			voucherTypeChange() {
				this.checkTechnicalOfficesVisibility();
			},
			terminalHospitalChange() {
				this.checkTechnicalOfficesVisibility();
			},
			async checkTechnicalOfficesVisibility() {
				let voucherType = '';
				let terminalHospital = '';
				let hospital = '';
				
				let isEdit = this.dialogVisibleoutboundorderedit;
				let refs = isEdit ? this.$refs.outupdate : this.$refs.outadd;
				if (!refs) return;
				
				voucherType = refs[3] && refs[3].modelvalue ? refs[3].modelvalue : '';
				hospital = refs[4] && refs[4].modelvalue ? refs[4].modelvalue : '';
				terminalHospital = refs[6] && refs[6].modelvalue ? refs[6].modelvalue : '';
				let isNewMode = refs[7] && refs[7].modelvalue == '1';
				
				let invClass = refs[2] && refs[2].modelvalue ? refs[2].modelvalue : '';
				
				let form = isEdit ? this.editformdatadialog : this.formdatadialog;
				
				let hosTypeIsHospital = false;
				if (form[6].selcoms === false && hospital) {
					hosTypeIsHospital = true;
				}
				
				let isSalesOrder = voucherType === '销售订单' || voucherType === '销售退货单';
				let hasHospital = (hosTypeIsHospital && hospital) || (!hosTypeIsHospital && terminalHospital);
				
				if (isSalesOrder) {
					form[10].selcoms = true;
					let targetHospitalId = hosTypeIsHospital ? hospital : terminalHospital;
					
					let arr = [];
					if (hasHospital) {
						if (this.lastTargetHospitalId !== targetHospitalId || this.lastInvClass !== invClass) {
							if (this.lastTargetHospitalId !== null) {
								refs[10].modelvalue = '';
							}
							this.lastTargetHospitalId = targetHospitalId;
							this.lastInvClass = invClass;
						}
						
						let { code, data } = await HelperTechnicalOfficesList({ Hospital: Number(targetHospitalId), InvClass: invClass });
						if (code === 0) {
							data.map(item => {
								arr.push({ key: item.Value, value: item.Text });
							});
						}
					} else {
						this.lastTargetHospitalId = null;
						if (refs[10]) refs[10].modelvalue = '';
					}
					
					form[10].options = arr;
					
					if (this.CusTypeFlog === 1) {
						if (isNewMode) {
							form[10].selcoms = true;
							if (arr.length === 0) {
								form[10].inputtype = "input";
								form[10].inputflag = true;
							} else {
								form[10].inputtype = "select";
								form[10].inputflag = false;
							}
						} else {
							form[10].selcoms = false;
							form[10].inputtype = "select";
							form[10].inputflag = false;
							if (refs[10]) refs[10].modelvalue = '';
						}
					} else {
						form[10].inputtype = "select";
						form[10].inputflag = false;
						if (!hasHospital) {
							form[10].selcoms = false; // hide if no hospital
						}
					}
				} else {
					form[10].selcoms = false;
					form[10].inputflag = false;
					form[10].inputtype = "select";
					if (refs[10]) refs[10].modelvalue = '';
					form[10].options = [];
					this.lastTargetHospitalId = null;
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			addclick() {
				this.hospital = this.Consignment ? this.$refs.outadd[12].modelvalue + '' : this.$refs.outadd[4]
					.modelvalue + '';
			},
			uaddclick() {
				this.hospital = this.Consignment ? this.$refs.outupdate[12].modelvalue + '' : this.$refs.outadd[4]
					.modelvalue + '';
			},
			commclick(type) {
				this[type] = true
			},
			cancelinvoicephoto() {

			},
			dialogOKinvoicephoto() {

			},
			addckd(val) {
				this.lastTargetHospitalId = null;
				this.formdatadialog[8].dateFlag = false;
				this.formdatadialog[9].inputflag = false;
				this.formdatadialog[10].inputflag = false;
				this.formdatadialog[11].inputflag = false;
				this.formdatadialog[12].selcoms = false;
				console.log(this.formdatadialog);
				this.Consignment = false;
				this.ConsignmentDisabled = false;
				this.formdatadialog[6].selcoms = false
				this.HosTypestate = 1
				this.dialogindex = "add"
				this.helperDPVoucherType()
				this.inventoryClassList()
				this.dialogVisibleoutboundorder = true
				this.$emit('addckd', val)
				return
			},
			updateckd() {
				if (this.handleData && this.handleData.length === 1 && this.editops === false) {
					this.dpmid = this.handleData[0].DPMID
					this.rowboo = true
				}
				if (this.rowboo == true) {
					this.lastTargetHospitalId = null;
					this.Consignment = false;
					this.ConsignmentDisabled = false;
					this.editformdatadialog[6].selcoms = false
					// this.CusType()
					this.wmsDespatchInfo()
					this.helperDPVoucherType()
					this.inventoryClassList()
					this.dialogVisibleoutboundorderedit = true
					this.dialogindex = "update"
					this.$emit('updateckd')
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});

			},
			canceloutboundorderedit() {
				this.$parent.wmsDespatchList()
				this.dialogVisibleoutboundorderedit = false
			},
			dialogOKcanceloutboundorderedit() {
				this.$parent.wmsDespatchList()
				this.$refs.outupdate.map((item, index) => {
					item.modelvalue = ''
				})
				this.$refs.AddDialog.tableDataDetail.length = 0
				this.$refs.AddDialog.tableDataDetailunNo.length = 0
				this.$refs.AddDialog.tableDataDetailUnique.length = 0
				this.dialogVisibleoutboundorderedit = false
			},
			canceloutboundorder() {
				this.$parent.wmsDespatchList()
				this.dialogVisibleoutboundorder = false
			},
			dialogOKcanceloutboundorder() {
				this.$parent.wmsDespatchList()
				this.$refs.outadd.map((item, index) => {
					item.modelvalue = ''
				})
				this.$refs.AddDialog.tableDataDetail.length = 0
				this.$refs.AddDialog.tableDataDetailunNo.length = 0
				this.$refs.AddDialog.tableDataDetailUnique.length = 0
				this.dialogVisibleoutboundorder = false
			},
			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false

			},
			select() {

			},
			reset() {

			},
			/** 
			 * 如果当前登录的是一级经销商
			 * 下拉框就是二级经销商
			 * */

			async CustomerList(query) {
				this.loading = true
				let {
					data,
					code
				} = await CustomerList({
					cusName: query,
					Actived: 1
				})
				if (code == 0) {
					this.formdatadialog[4].options = []
					this.editformdatadialog[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.formdatadialog[4].options.push(obj)
						this.editformdatadialog[4].options.push(obj)
					})
					this.loading = false
				}
			},
			/**
			 * 如果当前登录的是二级经销商
			 * 下拉框就是医院
			 */
			async HospitalList(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalList({
					hpName: query,
				})
				if (code == 0) {
					this.formdatadialog[4].options = []
					this.editformdatadialog[4].options = []
					this.formdatadialog[12].options = []
					this.editformdatadialog[12].options = []
					if (this.HosTypestate == 2) {
						this.formdatadialog[6].options = []
					}
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdatadialog[4].options.push(obj)
						this.editformdatadialog[4].options.push(obj)
						this.formdatadialog[12].options.push(obj)
						this.editformdatadialog[12].options.push(obj)
						if (this.HosTypestate == 2) {
							this.formdatadialog[6].options.push(obj)
						}
					})
				}
				this.loading = false
			},
			async remoteHosType(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalList({
					hpName: query,
				})
				if (code == 0) {
					this.formdatadialog[6].options = []
					this.editformdatadialog[6].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdatadialog[6].options.push(obj)
						this.editformdatadialog[6].options.push(obj)
					})
					console.log(this.formdatadialog);
				}
				this.loading = false
			},
			remoteMethodtows(query) {
				if (this.CusTypeFlog == 1) {
					this.CustomerList(query)
				} else if (this.CusTypeFlog == 2) {
					this.HospitalList(query) //经销商（医院接口）
				}
			},
			onRowClick(val) {
				if (this.handleData && this.handleData.length === 1) {
					this.rowboo = true
					this.dpmid = this.handleData[0].DPMID
					this.editops = this.handleData[0].Status == 0 ? false : true
				} else {
					this.editops = true
				}
				//console.log(val, "val")
				this.$emit("onRowClick", val)
			},
			DespatchExport() {
				this.$emit('DespatchExport')
			},
			invClass(e) {
				this.invClassCode = e.modelvalue
				this.inventoryClassInfo(e.modelvalue)
			},
			// 判断是否开启唯一码
			async inventoryClassInfo(invClass) {
				let {
					code,
					data
				} = await InventoryClassInfo({
					invClass: invClass
				})
				if (code == 0) {
					if (data.IsBarCodeControl == 1) {
						let arr = [{
								title: '明细'
							},
							{
								title: '唯一码'
							}
						]

						this.$refs.AddDialog.wtypestate = false
						this.$refs.AddDialog.Quantityflag = true
						this.Uniqueflag = true
						this.Detailflag = false
						this.state = arr

					} else if (data.IsBarCodeControl == 0) {
						let arr = [{
							title: '明细'
						}]
						// //console.log(this.$refs.AddDialog,'this.$refs.AddDialog');
						this.$refs.AddDialog.wtypes = 1
						this.$refs.AddDialog.onchage = 0
						this.$refs.AddDialog.wtypestate = true
						this.$refs.AddDialog.Quantityflag = false
						this.Uniqueflag = false
						this.Detailflag = true
						// this.wtype = 0
						this.state = arr
					}
				}
			},
			adduser() {
				this.dialogVisibles = true
				//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				// this.dialogVisibles = false
			},
			dialogOK() {
				// this.dialogVisibles = false
			},
			shen() {
				if (this.dpmidarr.length > 0) {
					this.dialogVisibleshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要审核的数据(多选)！'
				});
			},
			cancelshen() {
				this.dialogVisibleshen = false
			},
			dialogOKshen() {
				this.wmsDespatchVerify()
				this.dialogVisibleshen = false
			},
			qshen() {
				if (this.dpmidarr.length > 0) {
					this.dialogVisibleqshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要弃审的数据！'
				});


			},
			dialogOKqshen() {
				this.wmsDespatchUnVerify()
				this.dialogVisibleqshen = false
			},
			cancelqshen() {
				this.dialogVisibleqshen = false
			},
			del() {
				if (this.dpmidarr.length > 0) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			dialogOKdel() {
				this.wmsDespatchDelete()
				this.dialogVisibledel = false
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			cancelqsjg() {
				this.dialogVisiblesqsjg = false
			},
			dialogOKqsjg() {
				this.dialogVisiblesqsjg = false
			},
			GuidanceVideo() {
				this.dialogVisibGuidanceVideo = true
			},
			cancelGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
			dialogOKGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
			handleDrop(e) {
				if (e === 'a') {
					this.addckd()
				} else {
					this.wmsDespatchList();
					//this.dialogVisibleoutboundorder2 = true;
				}
			}, // 列表
			async wmsDespatchList() {
				await this.helperDPVoucherTypeForSelect()
				await this.inventoryClassList()
				await this.status()
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await wmsDespatchList({
					cusName: this.selectformparams.cusName,
					vouCode: this.selectformparams.vouCode,
					objName: this.selectformparams.objName,
					dpDate1: this.selectformparams.dpDate1,
					dpDate2: this.selectformparams.dpDate2,
					status: this.selectformparams.statuss,
					invClass: this.selectformparams.invClass,
					voucherType: this.selectformparams.voucherType,
					verifyTime1: this.selectformparams.verifyTime1,
					verifyTime2: this.selectformparams.verifyTime2,
					invAddCode: this.selectformparams.invAddCode,
					invName: this.selectformparams.invName,
					batch: this.selectformparams.batch,
					TerminalHPName: this.selectformparams.TerminalHPName,
					pageSize: this.pageSize2,
					pageIndex: this.pageindex2,
					ReferToBack: 1
				})
				console.log(code, data.data)
				if (code == 0) {
					this.dialogVisibleoutboundorder2 = true;
					this.total2 = data.Count
					loading.close();
					this.tableData2 = data.data
				} else {
					loading.close();
				}
			},
			// 明细
			async wmsDespatchDetail() {
				let {
					data,
					code
				} = await wmsDespatchDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
					//this.tableDataMD = data
				}
			},
			// 唯一码
			async wmsDespatchDetailUnique() {
				let {
					data,
					code,
					message
				} = await wmsDespatchDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataUnique = data
					//this.tableDataMD = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			handSelect() {
				for (let item of this.selectformdata) {
					this.selectformdatalist.push(item.inputdata)
				}
				this.pageindex = 1
				// 页码重置为1
				try {
					this.selectformparams.cusName = this.$refs.outselect[0].modelvalue
					this.selectformparams.vouCode = this.$refs.outselect[1].modelvalue
					this.selectformparams.dpDate1 = this.$refs.outselect[2].startTime
					this.selectformparams.dpDate2 = this.$refs.outselect[2].endTime
					this.selectformparams.objName = this.$refs.outselect[3].modelvalue
					this.selectformparams.statuss = this.$refs.outselect[4].modelvalue
					this.selectformparams.invClass = this.$refs.outselect[5].modelvalue
					this.selectformparams.verifyTime1 = this.$refs.outselect[6].startTime
					this.selectformparams.verifyTime2 = this.$refs.outselect[6].endTime
					this.selectformparams.voucherType = this.$refs.outselect[7].modelvalue
					this.selectformparams.invAddCode = this.$refs.outselect[8].modelvalue
					this.selectformparams.invName = this.$refs.outselect[9].modelvalue
					this.selectformparams.batch = this.$refs.outselect[10].modelvalue
					this.selectformparams.TerminalHPName = this.$refs.outselect[11].modelvalue
					this.wmsDespatchList()
				} catch (error) {
					this.wmsDespatchList()
				}
			},
			handReset() {
				for (let index in this.$refs.outselect) {
					if (index == 2 || index == 5) {
						this.$refs.outselect[index].startTime = ''
						this.$refs.outselect[index].endTime = ''
					} else {
						this.$refs.outselect[index].modelvalue = ''
					}
				}
			},
			handleCurrentChange2(pageindex) {
				this.pageindex2 = pageindex
				this.wmsDespatchList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange2(paegSzie) {
				this.pageSize2 = paegSzie
				this.wmsDespatchList()
			},
			onRowClickSel(val) {
				if (val.DPMID) {
					this.dpmid = val.DPMID
					this.wmsDespatchDetail()
					this.wmsDespatchDetailUnique()
				}
			},
			async invSel2() {
				let {
					data,
					code,
					message
				} = await GetDespatchDetailByDPMIDs({
					DPMIDs: this.dpmidarr2
				})
				if (code == 0) {
					//this.tableDataUnique = data
					//this.tableDataMD = data
					this.helperDPVoucherType()
					this.inventoryClassList()

					this.Consignment = data.Consignment ? true : false;
					this.ConsignmentDisabled = true;
					this.formdatadialog[2].disabled = true;
					this.formdatadialog[2].inputdata = data.InvClass;

					this.formdatadialog[3].disabled = true;
					this.formdatadialog[3].options = [{
						key: data.VoucherType,
						value: data.VoucherType
					}];
					this.formdatadialog[3].inputdata = data.VoucherType;

					this.formdatadialog[4].disabled = true;
					this.formdatadialog[4].options = [{
						key: data.Hospital,
						value: data.CusName
					}];
					this.formdatadialog[4].inputdata = data.Hospital;


					if (data.SellerType == "医院") {
						this.formdatadialog[6].selcoms = false
					} else {
						this.formdatadialog[6].selcoms = true
						this.formdatadialog[6].disabled = true;
						this.formdatadialog[6].options = [{
							key: data.TerminalHPID,
							value: data.TerminalHPName
						}];
						this.formdatadialog[6].inputdata = data.TerminalHPID;
					}

					this.$nextTick(() => {
						if (this.$refs.AddDialog.tableDataDetail) {
							this.$refs.AddDialog.tableDataDetail.length = 0
						}
						data.data.map((item, index) => {
							item.ID = index;
							return item;
						})
						this.$refs.AddDialog.tableDataDetail = data.data
						this.$refs.AddDialog.tableDataDetailunNo = data.data

						console.log(this.$refs.AddDialog.tableDataDetailunNo, 888888);
					})

					this.$forceUpdate();
					this.dialogVisibleoutboundorder = true;
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//今日不再提醒
			async dialogUnTips() {
				let {
					data,
					code,
					message
				} = await NoMoreWarningConvertRateToday(this.unTipsParams);
				if (code == 0) {
					this.dialogClose();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//弹窗关闭
			dialogClose() {
				this.unTipsParams = {};
				this.tableDataUpload = [];
				this.dialogVisibleUpload = false;
				this.dialogVisibleoutboundorder = false;
				this.dialogVisibleoutboundorderedit = false;
				this.$parent.wmsDespatchList()
			},
			handleCheckedCitiesChange(e) {
				console.log('add', e);
				this.formdatadialog[6].selcoms = e == 1 ? true : false;

				this.formdatadialog[8].dateFlag = e == 1 ? true : false;
				this.formdatadialog[9].inputflag = e == 1 ? true : false;
				this.formdatadialog[10].inputflag = e == 1 ? true : false;
				this.formdatadialog[11].inputflag = e == 1 ? true : false;
				
				this.checkTechnicalOfficesVisibility();
			},
			handleCheckedCitiesChangeEdit(e) {
				console.log('edit', e);
				this.editformdatadialog[6].selcoms = e == 1 ? true : false;

				this.editformdatadialog[8].dateFlag = e == 1 ? true : false;
				this.editformdatadialog[9].inputflag = e == 1 ? true : false;
				this.editformdatadialog[10].inputflag = e == 1 ? true : false;
				this.editformdatadialog[11].inputflag = e == 1 ? true : false;
				
				this.checkTechnicalOfficesVisibility();
			}
		},
		watch: {
			dialogVisibleoutboundorder: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.outadd.map((item, index) => {
							item.modelvalue = ''
						})
						this.formdatadialog[2].disabled = false;
						this.formdatadialog[2].inputdata = '';
						this.formdatadialog[3].disabled = false;
						this.formdatadialog[3].inputdata = '';
						this.formdatadialog[4].disabled = false;
						this.formdatadialog[4].inputdata = '';
						this.formdatadialog[6].selcoms = false
						this.formdatadialog[6].disabled = false;
						this.formdatadialog[6].inputdata = '';
						this.formdatadialog[7].disabled = false;
						this.formdatadialog[7].inputdata = '';
						this.formdatadialog[8].inputdata = '';
						this.formdatadialog[9].inputdata = '';
						this.formdatadialog[10].inputdata = '';
						this.formdatadialog[11].inputdata = '';
						this.$refs.AddDialog.tableDataDetail.length = 0
						this.$refs.AddDialog.tableDataDetailunNo.length = 0
						this.$refs.AddDialog.tableDataDetailUnique.length = 0
					}
				},
				deep: true
			},
			dialogVisibleoutboundorderedit: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.outupdate.map((item, index) => {
							item.modelvalue = ''
						})
						this.editformdatadialog[2].disabled = false;
						this.editformdatadialog[3].disabled = false;
						this.editformdatadialog[4].disabled = false;
						this.editformdatadialog[6].disabled = false;
					}
				},
				deep: true
			},
			dialogVisibGuidanceVideo: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						// 弹窗关闭暂定视频
						this.$refs.outbouVideo.$refs.videoPlayer.pause()
					}
				},
				deep: true
			},
			dialogVisibleoutboundorder2: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.dpmidarr2 = [];
						this.$refs.OutboudreRef2.$refs.fileTableSelect.clearSelection()
					}
				},
				deep: true
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.froms {
			width: 100%;

			.inputtopt {
				width: 980px;
				height: 90px;
				// box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
				border-bottom: 1px solid #f0f0f0;
				background-color: #ffffff;
				padding-top: 15px;
				padding-bottom: 70px;
				animation: shows 0.2s linear;
				overflow: hidden;
			}

			.inputtops {
				width: 980px;
				height: 0;
				// box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
				border-bottom: 1px solid #f0f0f0;
				border-top: 1px solid #f0f0f0;
				background-color: #ffffff;
				padding-top: 15px;
				padding-bottom: 70px;
				overflow: hidden;
				// animation: hides 0.5s ease-in;
			}
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.drop-down-link {
		margin: 10px;
		width: 100%;
		height: 32px;
		line-height: 32px;
		color: rgb(0, 0, 0);
		font-size: 14px;
		//background-color: rgb(249, 250, 252);
		border: 1px solid #e6e6e6;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		//
	}

	/deep/.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: rgb(255 235 235);
		color: #606266;
	}

	/deep/.el-checkbox__label {
		color: rgb(51, 51, 51);
		font-weight: 400;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: rgb(51, 51, 51);
		font-weight: 400;
	}
</style>
